import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Sanitizer, SecurityContext } from '@angular/core';

import { ModalComponent } from '../modal-component';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent extends ModalComponent<void> implements OnInit, AfterViewInit {

  public message: string;
  public title: string;

  @ViewChild('closeButton')
  public closeButton: ElementRef;
  private lastActiveElement: HTMLElement;

  constructor(
    private sanitizer: Sanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.lastActiveElement = document.activeElement as HTMLElement;
  }

  ngAfterViewInit() {
    this.closeButton.nativeElement.focus();
  }

  public setMessage(message: string): void {
    this.message = this.sanitizer.sanitize(SecurityContext.HTML, message);
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public close() {
    super.close();

    if (this.lastActiveElement) {
      this.lastActiveElement.focus();
    }
  }

}



// WEBPACK FOOTER //
// /dist/src/app/notify/alert/alert.component.ts